import React from 'react';
import classnames from 'classnames';

import './product-card.scss';
import { IProductDescription } from '../../../models/product/IProductDescription';
import { ImageDisplayType } from '../PlaceholderImage';
import ProductCover from '../productCover/ProductCover';

export interface IProps {
    className?: string;
    productDescription: IProductDescription;
    coverPlaceholder: string;
    wideCoverPlaceholder: string;
    overlayHtml?: string;

    onClick?: (productDescription: IProductDescription) => void;
    onCloseButtonClick?: (productDescription: IProductDescription) => void;
    onResumeButtonClick?: () => void;

    showPercentage?: boolean;
    percentageRead?: number;

    forcedTitle?: string;

    onHoverLabel?: string;

    centralIcon?: string;
    onCentralIconClick?: () => void;

    data?: string;
    onDragStart?: (e) => void;

    onTitleDoubleClick?: () => void;
}

export interface IState {
}

export class ProductCard extends React.Component <IProps, IState> {
    private hasBeenMounted: boolean;
    
    constructor(props: IProps){
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
    }

    public componentDidMount(){
        this.hasBeenMounted = true;
    }

    public componentWillUnmount(){
        this.hasBeenMounted = false;
    }

    public render(){
        const productDescription = this.props.productDescription;
        let coverPath = productDescription.coverPath;
        let height = 125;
        let width = 130;
        
        if(productDescription.isWideCover){
            height = 194;
            width = 368;
        }

        return <div className={classnames("product-card-root", {"wide-product-card": productDescription.isWideCover, "fade-on-selection": !!this.props.onHoverLabel}, this.props.className)} 
                    data-product-id={productDescription.manningId || productDescription.id}
                    onClick={this.handleClick}>
                    {<ProductCover placeholderImage = {productDescription.isWideCover ? this.props.wideCoverPlaceholder : this.props.coverPlaceholder}
                                  imageDisplayType = {ImageDisplayType.Image}
                                  fullImage = {coverPath}
                                  className = {this.getProductTypeClassName()}
                                  height={height}
                                  width={width}
                                  alt = {(productDescription.title || "").indexOf("<") >= 0 ? "" : productDescription.title}
                                  placeholderOnlyOnFail={false}
                                  isLiveaudio={productDescription.isLiveaudio}
                                  key={productDescription.manningId || productDescription.id}
                                  data={this.props.data}
                                  onDragStart={this.props.onDragStart}/>}
                    { this.renderPercentageIfNecessary()}
                    { this.props.overlayHtml 
                    && <div className="product-card-overlay-text-container">
                            <span className="product-card-overlay-text" dangerouslySetInnerHTML={{__html: this.props.overlayHtml}}></span>
                       </div> }

                    {this.props.forcedTitle || productDescription.title 
                    ?  <div className={"product-card-title"} dangerouslySetInnerHTML={{__html: this.props.forcedTitle || productDescription.title}} onDoubleClick={this.props.onTitleDoubleClick}></div>
                    : null }
                    
                    { this.props.onHoverLabel 
                    && <a href={productDescription.contentLink || productDescription.link} className="product-card-resume-button" onClick={this.props.onResumeButtonClick} title={this.props.onHoverLabel} target='_blank'>{this.props.onHoverLabel}</a>}

                    { this.props.centralIcon
                    && <button className="_central-icon" onClick={this.props.onCentralIconClick}>
                            <i className={classnames("fa", this.props.centralIcon)}></i>
                        </button>}

                    { this.props.onCloseButtonClick
                    && <button className="product-card-close-button" title="remove" onClick={this.handleCloseButtonClick}>
                            <i className="fa fa-times"/>
                        </button>}
               </div>
    }

    private renderPercentageIfNecessary(){
        if(!this.props.showPercentage) { return null; }

        return  <div className={"percentage-line"}>
                    {typeof this.props.percentageRead == "undefined" 
                    ? <div className="loading-line"></div>
                    : <div className="filling-line" style={{width: `${this.props.percentageRead}%`}}></div>}
                </div>
    }

    private handleCloseButtonClick(e){
        e && e.preventDefault && e.preventDefault();
        e && e.stopPropagation && e.stopPropagation();

        this.props.onCloseButtonClick && this.props.onCloseButtonClick(this.props.productDescription);
    }

    private handleClick(){
        this.props.onClick && this.props.onClick(this.props.productDescription);
    }

    private getProductTypeClassName(): string {
        return `${this.props.productDescription.productType}-cover`;
    }
}
